export const RESET = 'RESET'; // eslint-disable-line
